import { render, staticRenderFns } from "./MedireInfo.vue?vue&type=template&id=65d8ed5c&scoped=true&"
import script from "./MedireInfo.vue?vue&type=script&lang=js&"
export * from "./MedireInfo.vue?vue&type=script&lang=js&"
import style0 from "./MedireInfo.vue?vue&type=style&index=0&id=65d8ed5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d8ed5c",
  null
  
)

export default component.exports